import configureLogger from "@asosteam/asos-web-logging";
import packageInfo from "../../package.json";

const { name } = packageInfo;

export default configureLogger({
  moduleName: name
});
